


























































































import {
  Breadcrumbs
} from '@/components/layout';
import { AppCardTotalLayout } from '@/uikit';
import AppHeading from '@/uikit/typography/Heading/AppHeading.vue';
import AppPicture from '@/uikit/components/AppPicture/AppPicture.vue';
import { AppText } from '@/uikit';
import ComponentsSpinnersWrapper from '@/components/spinners/swrapper';
import TabsMenu from '@/components/parts/tab/menu';

import BreadcrumbMixin from '@/mixins/breadcrumbs';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
export default {
  name: "OrganizationSpace",
  mixins: [
    BreadcrumbMixin
  ],
  components: {
    AppButtonNew,
    AppCardTotalLayout,
    AppHeading,
    AppPicture,
    AppText,
    ComponentsSpinnersWrapper,
    Breadcrumbs,
    TabsMenu
  },
  data() {
    return {
      pageTitle: null,

      partnerId: null,
      spaceId: null,

      partner: null,
      space: null,
      inventory: [],


      menu: [
        {title: 'Оборудование'}
      ],
      activeTab: 1
    }
  },
  computed: {
    breadcrumbsExtended() {
      const { breadcrumbs, pageTitle } = this;
      return [
        ...breadcrumbs,
        { text: 'Организации', to: { name: 'organizations' } },
        { text: this?.partner?.name, to: {name: 'organization', params: { id: this.partnerId } } },
        { text: pageTitle },
      ];
    },
    isLoaded() {
      return !!(this.space && this.partner && this.inventory)
    },
    isOvz() {
      return this.space.is_ovz ? 'Да' : 'Нет';
    },
    image() {
      return this.space?.image?.original || '';
    }
  },
  async created() {
    // console.log(!!(this.space && this.partner && this.inventory));

    this.partnerId = this.$route.params.partnerId;
    this.spaceId = this.$route.params.id;

    this.space = (await this.$axiosInstance.get(`inventory-object/get/${this.partnerId}`)).data.data.find((el: any) => el.id === this.spaceId);;
    this.partner = (await this.$axiosInstance.get(`organization/get`, { params: {id: this.partnerId  } }))?.data.data;
    this.inventory = (await this.$axiosInstance.get(`inventory-equipment/get/${this.partnerId}`))?.data.data.filter((el: any) => el.object_id === this.spaceId);

    this.pageTitle = this.space.name;
  },
  methods: {
    changeTabMenu(index: number) {
      this.activeTab = index;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/organizations/organization-space/OrganizationSpace.vue